import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Ticket } from 'src/app/models/core/ticket.model';
import { TicketActionsService } from 'src/app/services/ticket/ticket-actions.service';

@Component({
  selector: 'app-confirm-clone-modal',
  templateUrl: './confirm-clone-modal.component.html',
  styleUrls: ['./confirm-clone-modal.component.scss'],
  standalone: false
})
export class ConfirmCloneModalComponent {
  @Input() ticket!: Ticket;
  isCloning = false;

  constructor(
    private modalCtrl: ModalController,
    private ticketActionsService: TicketActionsService,
  ) { }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async cloneTicket() {
    this.isCloning = true;
    try {
      const createTicketData = {
        product_id: this.ticket.product.id,
        quantity_persons: this.ticket.quota ?? 1,
        payment_status: 1,
        payment_method: 'cash',
        reference: this.ticket.reference || '',
      };

      const newTicket = await this.ticketActionsService.generateTicket(createTicketData);

      await this.modalCtrl.dismiss(
        { newTicket },
        'cloned'
      );
    } catch (error) {
      console.error('Error clonando el ticket:', error);
    } finally {
      this.isCloning = false;
    }
  }

}
